import { computed, getCurrentInstance } from 'vue';

/**
 * コンポーネント名取得
 */
export function useComponentName() {
    const vm = getCurrentInstance();

    const componentName = computed(() => vm.proxy?.$options.__name);

    return { componentName };
}
